import { render } from "./ModalGuardarEjecicio.vue?vue&type=template&id=008b5478&scoped=true"
import script from "./ModalGuardarEjecicio.vue?vue&type=script&lang=js"
export * from "./ModalGuardarEjecicio.vue?vue&type=script&lang=js"

import "./ModalGuardarEjecicio.vue?vue&type=style&index=0&id=008b5478&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008b5478"]])

export default __exports__